module.exports = __webpack_public_path__ + "img/grafico.114f0d66.svg";